import { ActionButton, Dialog, cn } from "@eisox/design-system";
import { ArrowRightIcon, CalendarIcon } from "@eisox/icons";

import { m } from "~/paraglide/messages";

import { UnusualAbsenceScheme } from "./unusual-absence-scheme";

interface UnusualAbsenceDialogProps extends Dialog.RootProps {
  absenceTemperature: number;
  preComfortTemperature?: number;
  comfortTemperature?: number;
}

export const UnusualAbsenceDialog: React.FC<UnusualAbsenceDialogProps> = ({
  absenceTemperature,
  preComfortTemperature,
  comfortTemperature,
  children,
  ...props
}) => (
  <Dialog.Root {...props}>
    <Dialog.Trigger asChild>{children}</Dialog.Trigger>
    <Dialog.Content
      className={cn("md:max-w-[856px] flex w-full flex-col items-center gap-y-[40px]")}
      title={m.unusual_absence_detection()}
      icon={
        <CalendarIcon className="[&_svg]:h-6 [&_svg]:w-6 bg-primary-gray opacity-100 [&_svg]:fill-primary-dark-blue" />
      }
    >
      <p className="font-normal text-justify text-base leading-[21px]">{m.unusual_absence_detection_popup_text()}</p>
      <UnusualAbsenceScheme
        absenceTemperature={absenceTemperature}
        preComfortTemperature={preComfortTemperature}
        comfortTemperature={comfortTemperature}
      />
      <Dialog.Close asChild>
        <ActionButton className="mx-auto max-w-fit">
          {m.close()}
          <ArrowRightIcon />
        </ActionButton>
      </Dialog.Close>
    </Dialog.Content>
  </Dialog.Root>
);

UnusualAbsenceDialog.displayName = "UnusualAbsenceDialog";
